import { Plate } from '../ui/chrome';
import { PreregForm } from '../ui/Prereg';
import { useI18n } from '../i18n';

/** /prereg: the sign-up on its own page, for posts and the shared-chapter reader to link to. */
export function PreregPage() {
  const { t } = useI18n();
  return (
    <div className="prereg-page">
      <div className="wrap">
        <div className="card prereg-card">
          <div className="prereg-art">
            <img src="/art/splash_colour.webp" alt="" width={820} height={1229} />
          </div>
          <div className="prereg-side">
            <Plate as="h1" large petal>
              {t('prereg.pageTitle')}
            </Plate>
            <p className="prereg-lead">{t('prereg.pageLead')}</p>
            <PreregForm source="prereg" compact />
          </div>
        </div>
      </div>
    </div>
  );
}
